import { constants } from '@atlas/core';

export const bonusTransactionHistoryFilter = [
  constants.TRANSACTION_TYPE.BONUS_ACTIVATE,
  constants.TRANSACTION_TYPE.BONUS_COMPLETE,
  constants.TRANSACTION_TYPE.BONUS_DEACTIVATE,
];
